import countryJson from '../../files/country.json';

class List {
  country = () => countryJson;
}

const ListService = new List();
Object.freeze(ListService);
export { ListService };
